import F from '../../commons/HTTPFetcher';
import qs from 'qs';

import * as ContentTypes from '../../commons/constants/HTTPContentTypes';
import { getScrollStart, getScrollFailure } from './scroll';

import {
  PENDING_GET_TAX_AUDIT_LOG_ACTION,
  SUCCESS_GET_TAX_AUDIT_LOG_ACTION,
  FAILURE_GET_TAX_AUDIT_LOG_ACTION,
  RESET_TAX_AUDIT_LOG_ACTION,
  PENDING_GET_TAX_AUDIT_LOG_DETAILS_ACTION,
  SUCCESS_GET_TAX_AUDIT_LOG_DETAILS_ACTION,
  FAILURE_GET_TAX_AUDIT_LOG_DETAILS_ACTION,
  RESET_TAX_AUDIT_LOG_DETAILS_ACTION
} from '../actionsTypes';

const operatorMapper = {
  exists: 'EXISTS',
  notExists: 'NOT_EXISTS',
  contains: 'CONTAINS',
  '=': 'EQUAL',
  notEqual: 'NOT_EQUAL'
};

export const getPayload = ({ id: fslEntryId, merchantId, blockId: fslBlockId, userId }) => async (
  dispatch
) => {
  dispatch(getPayloadStart());
  try {
    const url = '/pub/fiscal/blockchain/fsl';
    const urlSearch = qs.stringify({ fslEntryId, fslBlockId, userId, merchantId }, { addQueryPrefix: true });

    const response = await F.get(`${url}${urlSearch}`);

    dispatch(getPayloadSucceeded());

    return response;
  } catch (errors) {
    dispatch(getPayloadFailure({ errors }));
    return null;
  }
};

export const getPayloadStart = () => ({
  type: PENDING_GET_TAX_AUDIT_LOG_DETAILS_ACTION
});

export const getPayloadSucceeded = () => ({
  type: SUCCESS_GET_TAX_AUDIT_LOG_DETAILS_ACTION
});

export const getPayloadFailure = (errors) => ({
  type: FAILURE_GET_TAX_AUDIT_LOG_DETAILS_ACTION,
  payload: {
    errors
  }
});

export const resetPayload = () => ({
  type: RESET_TAX_AUDIT_LOG_DETAILS_ACTION
});

export const getLogs = ({
  filters = [],
  fields,
  sort = { field: 'eventCreateDate', order: 'DESC' },
  tableCount,
  scrollOffset = 0,
  timePeriod,
  merchantId
}) => async (dispatch) => {
  const initialRequest = scrollOffset === 0;

  dispatch(initialRequest ? getLogsStart() : getScrollStart({ type: 'TAX_AUDIT_LOG' }));
  try {
    const url = '/pub/fiscal/blockchain/fsl';
    sort.field = sort.field.replace(/^log\./, '').replace(/\.raw$/, '');

    filters = filters.filter(({ name }) => name !== 'ecrContext.merchantId');
    filters.push({
      name: 'ecrContext.merchantId',
      operator: 'EQUAL',
      value: [`${merchantId}`]
    });
    filters = filters.map(({ filterType, operator, value, name, ...filter }) => ({
      ...filter,
      value: Array.isArray(value) ? value : [value],
      name:
        name.includes('ecrContext') || ['eventType', 'originType', 'status'].includes(name)
          ? name
          : `ecrContext.${name}`,
      operator: Object.keys(operatorMapper).includes(operator) ? operatorMapper[operator] : operator
    }));

    if (timePeriod) {
      filters = filters.filter(({ name }) => name !== 'eventCreateDate');
      filters.push({
        name: 'eventCreateDate',
        operator: 'BETWEEN',
        value: [
          timePeriod.startTime.clone().utc().format('YYYY-MM-DDTHH:mm:ss.SSS\\Z'),
          timePeriod.endTime.clone().utc().format('YYYY-MM-DDTHH:mm:ss.SSS\\Z')
        ]
      });
    }

    if (!['eventType', 'originType', 'status', 'eventCreateDate', 'createDate'].includes(sort.field)) {
      sort.field = `ecrContext.${sort.field}`;
    }

    if (!['eventCreateDate', 'createDate'].includes(sort.field)) {
      sort = [sort, { field: 'eventCreateDate', order: 'DESC' }];
    }

    const { searchResults: response, count } = await F.post(url, {
      body: {
        filters,
        fields,
        sorts: Array.isArray(sort) ? sort : [sort],
        page: {
          number: scrollOffset,
          limit: tableCount
        }
      },
      contentType: ContentTypes.JSON
    });
    return dispatch(
      initialRequest
        ? getLogsSucceeded({
            count,
            scrollId: scrollOffset + 1,
            data: response
          })
        : getScrollSucceeded({ data: response, scrollId: scrollOffset + 1 })
    );
  } catch (errors) {
    dispatch(
      initialRequest ? getLogsFailure({ errors }) : getScrollFailure({ type: 'TAX_AUDIT_LOG', errors })
    );
    throw errors;
  }
};

export const getLogsStart = () => ({
  type: PENDING_GET_TAX_AUDIT_LOG_ACTION
});

export const getLogsSucceeded = ({ count, scrollId, data }) => ({
  type: SUCCESS_GET_TAX_AUDIT_LOG_ACTION,
  payload: {
    count,
    scrollId,
    data
  }
});

export const getLogsFailure = (errors) => ({
  type: FAILURE_GET_TAX_AUDIT_LOG_ACTION,
  payload: {
    errors
  }
});

export const resetLogs = () => ({
  type: RESET_TAX_AUDIT_LOG_ACTION
});

export const getScrollSucceeded = ({ data, scrollId }) => {
  const type = `SUCCESS_GET_TAX_AUDIT_LOG_SCROLL_ACTION`;

  return {
    type,
    payload: {
      scrollId,
      data
    }
  };
};

const getFieldsStart = () => ({
  name: 'LOGS',
  type: `PENDING_GET_FIELDS_ACTION_LOGS`
});

export const getFields = () => async (dispatch) => {
  dispatch(getFieldsStart());
  dispatch({
    type: 'SUCCESS_GET_FIELDS_ACTION_LOGS',
    name: 'LOGS',
    payload: {
      fields: [
        {
          extras: false,
          searchable: true,
          required: false,
          type: 'string',
          visible: true,
          key: 'userId'
        }
      ]
    }
  });
};
